import { render, staticRenderFns } from "./about.vue?vue&type=template&id=dc5ad894&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports